import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './common/auth-guard.service';
import { HomeComponent } from './inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { BPRecordsComponent } from './inside-of-application/bprecords/bprecords.component';
import { BprecordsDetailsComponent } from './inside-of-application/bprecords-details/bprecords-details.component';
import { ECCIDDetailsComponent } from './inside-of-application/eccid-details/eccid-details.component';
import { UploadExcelDataComponent } from './inside-of-application/upload-excel-data/upload-excel-data.component';
// import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    // { path: 'login', component: LoginComponent, canActivate: [MsalGuard] },
    { path: 'login', component: LoginComponent},
    { path: 'dummylogin', component: DummyLoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'unauthorize', component: UnAuthorizeComponent },
    { path: 'badrequest', component: BadRequestComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },
    {
        path: 'home', component: HomeComponent, canActivate: [AuthGuardService],
        children: [
            {
                path: '', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'clientserverbprecords', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'dpcbprecords', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'bprecordsall', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'financebprecordsall', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'clientbprecordsall', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'clientbprecordsalluser', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'dpcbprecordsall', component: BPRecordsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'bprecorddetail', component: BprecordsDetailsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'ecciddetails', component: ECCIDDetailsComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'UploadExcelData', component: UploadExcelDataComponent, canActivate: [AuthGuardService]
            },
        ]
    },
    {
        path: 'admin', component: HomeComponent, canActivate: [AuthGuardService],
        children: [
            {
                path: '', component: DashboardComponent, canActivate: [AuthGuardService]
            },
        ]
    },
    { path: '**', redirectTo: 'pagenotfound' }
];

@NgModule({
    // imports: [RouterModule.forRoot(routes, { useHash: true })],
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    // providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},AuthGuardService]
    providers: [AuthGuardService]
})
export class AppRoutingModule {
}
